import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import NameAndStatus from '@blade-sxp/task-management/components/name-status.vue';
import DeviceDarwer from '@blade-sxp/task-management/components/deviceDarwer/index.vue';
import ValidTime from '@blade-sxp/task-management/components/valid-time1.vue';
import AlarmLevel from '@blade-sxp/task-management/components/alarm-level.vue';
import FrequencyAndThreshold from '@blade-sxp/task-management/components/frequency-threshold.vue';
import ButtonBox from '@blade-sxp/task-management/components/button-box.vue';
import { isEmpty, cloneDeep } from 'lodash';
import { DeviceIdDataModule } from '@blade-sxp/task-management/store/deviceIdData';
import { postTask, updateTask, getTaskDetail } from '@blade-sxp/task-management/api/creat-task/index';
import { plotMap } from '@blade-sxp/task-management/components/deviceDarwer/plotConfig';
import RetentionTime from '@blade-sxp/task-management/components/retention-time.vue';
import DeviceCascader from '@blade-sxp/task-management/components/device-cascader.vue';
import TaskNote from '@blade-sxp/task-management/components/task-note.vue';
const Service = {
    postTask,
    updateTask,
    getTaskDetail,
};
let CrowdStrand = class CrowdStrand extends Vue {
    taskType = '';
    name = '';
    status = 'ENABLE';
    effectivePeriod = 'PERMANENT';
    effectiveDates = {
        start: '',
        end: '',
    };
    effectiveTimes = [{ start: '', end: '' }];
    dayOfWeeks = [];
    alertInterval = 10;
    type = 'add';
    isError = false;
    isDetail = false;
    isReady = false;
    loading = true;
    level = 'CRITICAL';
    id = '';
    configType = '';
    disableRight = false;
    retentionTime = 0;
    remark = '';
    get isRetentionTime() {
        return this.taskType === 'CROWD_STRAND';
    }
    get formData() {
        if (this.isRetentionTime) {
            const { name, effectivePeriod, effectiveDates, effectiveTimes, dayOfWeeks, isReady, alertInterval, retentionTime } = this;
            return {
                name,
                effectivePeriod,
                effectiveDates,
                effectiveTimes,
                dayOfWeeks,
                isReady,
                alertInterval,
                retentionTime,
            };
        }
        else {
            const { name, effectivePeriod, effectiveDates, effectiveTimes, dayOfWeeks, isReady, alertInterval } = this;
            return {
                name,
                effectivePeriod,
                effectiveDates,
                effectiveTimes,
                dayOfWeeks,
                isReady,
                alertInterval,
            };
        }
    }
    init() {
        const { type, id, taskType } = this.$route.query;
        this.type = type;
        this.taskType = taskType;
        this.id = id;
        this.isDetail = type === 'detail';
        if (taskType === 'CROWD_INTRUSION') {
            this.configType = 'intrusionConfig';
        }
        else {
            this.configType = 'crowdStrandConfig';
        }
        if (this.type === 'add') {
            this.loading = false;
        }
        else {
            if (this.isDetail) {
                this.disableRight = false;
            }
            this.getData();
        }
    }
    async validForm() {
        if (this.isDetail) {
            return;
        }
        if (!this.isReady) {
            this.disableRight = true;
            return;
        }
        let refNum = 0;
        if (this.isRetentionTime) {
            refNum = 5;
        }
        else {
            refNum = 4;
        }
        for (let i = 1; i <= refNum; i++) {
            if (this.$refs['ruleForm' + i]) {
                let res = await this.$refs['ruleForm' + i].isValidate();
                if (!res) {
                    this.disableRight = true;
                    return;
                }
            }
        }
        this.disableRight = false;
    }
    mounted() {
        const taskType = this.$route.query.taskType;
        if (taskType) {
            this.taskType = taskType;
        }
    }
    clickRightButton() {
        if (this.type === 'detail') {
            const url = this.$route.path;
            this.$router.push({ path: url, query: { type: 'update', taskType: this.taskType, id: this.id } });
            this.$route.meta.title = this.$route.meta.title.replace('look', 'edit');
        }
        else {
            this.submit();
        }
    }
    submit() {
        let taskStatus = '';
        if (this.type === 'update') {
            if (this.isError && this.status === 'DISABLE') {
                taskStatus = 'DISABLE';
            }
            else if (this.isError && this.status === 'ENABLE') {
                taskStatus = 'ERROR';
            }
            else {
                taskStatus = this.status;
            }
        }
        else {
            taskStatus = this.status;
        }
        const effectiveTimes = [];
        if (this.effectivePeriod === 'CUSTOMIZE') {
            this.effectiveTimes.forEach((item) => {
                effectiveTimes.push({ start: item.effectiveTimes[0], end: item.effectiveTimes[1] });
            });
        }
        const params = {
            taskName: this.name,
            remark: this.remark,
            taskStatus: taskStatus,
            taskType: this.taskType,
            alarmConfig: {
                enable: true,
                notifyConfig: {
                    enabledAlarmLevels: [this.level],
                    frequency: {
                        unit: 'MINUTE',
                        value: this.alertInterval,
                    },
                },
                thresholdConfigs: [
                    {
                        effectivePeriod: this.effectivePeriod,
                        dayOfWeeks: this.dayOfWeeks,
                        effectiveTimes: this.effectivePeriod === 'PERMANENT' ? [] : [...effectiveTimes],
                        effectiveDates: this.effectivePeriod === 'PERMANENT' ? [] : [this.effectiveDates],
                        levelConfig: {
                            [this.level.toLowerCase()]: this.alertInterval,
                            unit: 'PERCENT',
                        },
                        threshold: {
                            type: 'TIMING',
                            value: this.retentionTime,
                        },
                    },
                ],
            },
            deviceTaskConfigs: this.fromDataDeviceConfig(),
        };
        if (this.type === 'add' || this.type === 'copy') {
            Service.postTask(params).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
        else {
            Service.updateTask({ taskId: this.id, ...params }).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
    }
    fromDataDeviceConfig() {
        const config = [];
        let device = DeviceIdDataModule.deviceIdRequestParams;
        let requestMap = new Map();
        requestMap = cloneDeep(device);
        const incidentType = plotMap.get(this.taskType).incidentType;
        if (!isEmpty(requestMap) && !isEmpty(incidentType)) {
            requestMap.forEach((item) => {
                const { zoneId, deviceId, titleList } = item;
                let persons = [];
                let rawRoi = [];
                if (!isEmpty(titleList)) {
                    titleList.forEach((item) => {
                        if (item.type === 'BODY') {
                            item.data.forEach((item) => {
                                let pern = {
                                    x: item.vertices[0].y > item.vertices[1].y ? item.vertices[1].y : item.vertices[0].y,
                                    y: item.vertices[0].y < item.vertices[1].y ? item.vertices[1].y : item.vertices[0].y,
                                };
                                persons.push(pern);
                            });
                        }
                        if (item.type === 'ROI') {
                            item.data.forEach((item) => {
                                const { vertices, id } = item;
                                vertices.shift();
                                rawRoi.push({
                                    rawRoi: {
                                        vertices,
                                        id: this.taskId(),
                                        name: id,
                                    },
                                });
                            });
                        }
                    });
                }
                let data = {
                    [this.configType]: {
                        roiMappings: rawRoi,
                    },
                    labelPersons: persons,
                    zoneId,
                    deviceId,
                    incidentType,
                    roiData: JSON.stringify(device.get(deviceId)),
                };
                config.push(data);
            });
        }
        return config;
    }
    cancel() {
        if (this.type === 'detail') {
            this.$router.push('/tasklist');
        }
        else {
            this.$confirm(`${this.$t('cancelSubmitTip')}`, `${this.$t('tip')}`, {
                confirmButtonText: `${this.$t('confirm')}`,
                cancelButtonText: `${this.$t('cancel')}`,
                cancelButtonClass: 'cancel-roi-tip',
                confirmButtonClass: 'confirm-roi-tip',
                customClass: 'task-confirm',
            })
                .then(() => {
                this.$router.push('/tasklist');
            })
                .catch(() => { });
        }
    }
    taskId() {
        const num = Math.random() * 100000;
        return Math.round(num);
    }
    getData() {
        Service.getTaskDetail(Number(this.id))
            .then(({ name, status, remark, alarmConfig: { thresholdConfigs }, deviceTaskConfigs }) => {
            this.name = name;
            this.remark = remark;
            if (status === 'ERROR') {
                this.isError = true;
                this.status = 'ENABLE';
            }
            else {
                this.status = status;
            }
            if (thresholdConfigs) {
                const { dayOfWeeks, effectiveDates, effectivePeriod, effectiveTimes, levelConfig, threshold } = thresholdConfigs[0];
                this.dayOfWeeks = dayOfWeeks;
                this.effectivePeriod = effectivePeriod;
                if (this.effectivePeriod !== 'PERMANENT') {
                    this.effectiveDates = effectiveDates[0];
                    this.effectiveTimes = effectiveTimes.map((item) => {
                        return { ...item, effectiveTimes: [item.start, item.end] };
                    });
                }
                for (let key in levelConfig) {
                    if (levelConfig[key]) {
                        this.alertInterval = levelConfig[key];
                        this.level = key.toUpperCase();
                    }
                }
                if (!isEmpty(deviceTaskConfigs)) {
                    deviceTaskConfigs.forEach((item) => {
                        const roiData = item.roiData;
                        if (!isEmpty(roiData)) {
                            const analysis = JSON.parse(roiData);
                            DeviceIdDataModule.deviceIdRequestParams.set(analysis.id, analysis);
                        }
                    });
                }
                if (this.isRetentionTime) {
                    this.retentionTime = threshold.value;
                }
            }
        })
            .finally(() => {
            this.loading = false;
        });
    }
};
__decorate([
    Watch('$route', { immediate: true, deep: true })
], CrowdStrand.prototype, "init", null);
__decorate([
    Watch('formData', { deep: true, immediate: true })
], CrowdStrand.prototype, "validForm", null);
CrowdStrand = __decorate([
    Component({
        name: 'CrowdStrand',
        components: {
            'st-device-darwer': DeviceDarwer,
            'name-and-status': NameAndStatus,
            'valid-time': ValidTime,
            'alarm-level': AlarmLevel,
            'frequency-and-threshold': FrequencyAndThreshold,
            'button-box': ButtonBox,
            'retention-time': RetentionTime,
            'device-cascader': DeviceCascader,
            'task-note': TaskNote,
        },
        i18n: {
            messages: {
                en: {
                    alert: 'Alert Notification',
                    cancelSubmitTip: 'Data will not be saved and exited, are you sure to exit?',
                    tip: 'Title',
                    confirm: 'Confirm',
                    cancel: 'Cancel',
                },
                zh: {
                    alert: '告警通知',
                    cancelSubmitTip: '数据将不会保存并退出，确定退出吗？',
                    tip: '提示',
                    confirm: '确定',
                    cancel: '取消',
                },
            },
        },
    })
], CrowdStrand);
export default CrowdStrand;
